/* eslint-disable */
/**
 * https://gist.github.com/TheBrenny/039add509c87a3143b9c077f76aa550b
 */

if (!String.prototype.matchAll) {
  // @ts-ignore
  String.prototype.matchAll = function (rx) {
    if (typeof rx === 'string') rx = new RegExp(rx, 'g') // coerce a string to be a global regex
    rx = new RegExp(rx) // Clone the regex so we don't update the last index on the regex they pass us
    let cap = [] // the single capture
    const all = [] // all the captures (return this)
    while ((cap = rx.exec(this)) !== null) all.push(cap) // execute and add
    return all // profit!
  }
}
